// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"68be2e5b","143":"10572574","226":"40b472a7","453":"68693753","677":"c2f0f094","954":"dac165b2"}[chunkId] + ".chunk.js";
};